import { Col, Form, Input, Label, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Cancel, Collection, Description, Group, MyBookmark, Save, Title, WebUrl } from "../../../../Constants/Constants";
import { EditBookmarkModalFormType } from "../../../../Types/BookmarkType";

export const EditBookmarkModalForm:React.FC<EditBookmarkModalFormType> = ({ register, errors, editToggle, handleSubmit, updateBookMarkData }) => {
  return (
    <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(updateBookMarkData)}>
      <Row className="g-2">
        <Col md="12" className="mb-3 mt-0">
          <Label>{WebUrl}</Label>
          <input className="form-control" type="text" {...register("url", { required: true })} />
          {errors.url && <span className="text-danger">Url is required</span>}
        </Col>
        <Col md="12" className="mt-0 mb-3">
          <Label>{Title}</Label>
          <input className="form-control" type="text" {...register("title", { required: true })} />
          {errors.title && <span className="text-danger">Title is required</span>}
        </Col>
        <Col md="12" className="mt-0 mb-3">
          <Label>{Description}</Label>
          <input className="form-control" type="textarea" {...register("desc", { required: true })} />
          {errors.desc && <span className="text-danger">Description is required</span>}
        </Col>
        <Col md="6" className="mt-0 mb-3">
          <Label>{Group}</Label>
          <Input type="select" name="group">
            <option value="bookmark">{MyBookmark}</option>
          </Input>
        </Col>
        <Col md="6" className="mt-0 mb-3">
          <Label>{Collection}</Label>
          <Input type="select" name="collection">
            <option value="General">General</option>
            <option value="Fs">Fs</option>
          </Input>
        </Col>
      </Row>
      <Btn color="primary" type="submit" className="me-1">{Save}</Btn>
      <Btn color="secondary" onClick={editToggle}>{Cancel}</Btn>
    </Form>
  );
};
